import { Button } from "../../ui"

// Review-before-send popup for an order submit/resubmit. `rows` is
// [{ label, value, full? }]; `children` slots in extra input (e.g. a note).
export default function OrderSubmitConfirmModal({ title, rows, busy, onCancel, onConfirm, children, maxWidth }) {
  return (
    <div
      className="pc-modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.target === e.currentTarget && !busy) onCancel()
      }}
    >
      <div className="pc-modal" style={maxWidth ? { maxWidth } : undefined}>
        <div className="pc-modal-head">
          <div className="pc-modal-title">{title}</div>
        </div>
        <div className="pc-modal-body">
          <div className="pc-defgrid">
            {rows
              .filter((r) => r.value !== undefined && r.value !== null && r.value !== "")
              .map((r) => (
                <div key={r.label} className={r.full ? "pc-def-full" : undefined}>
                  <div className="pc-def-label">{r.label}</div>
                  <div className="pc-def-value">{r.value}</div>
                </div>
              ))}
          </div>
          {children && <div style={{ marginTop: 16 }}>{children}</div>}
        </div>
        <div className="pc-modal-foot">
          <Button variant="secondary" onClick={onCancel} disabled={busy}>
            Go back
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={busy}>
            {busy ? "Sending…" : "Send"}
          </Button>
        </div>
      </div>
    </div>
  )
}
